/**
 * Lives in its own module so pipeline.ts can stamp it into a serialised
 * preset without importing the barrel (index.ts re-exports pipeline.ts, so
 * that would be a cycle).
 */
export const ENGINE_VERSION = '0.1.0';
